import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from "../../Style/MoaStyled";
import { DataGrid, GridToolbar, GridToolbarContainer, GridToolbarExport, } from "@mui/x-data-grid";
import Color from "../../Style/Color";
import MoaCheck from '../Check';
;
var StyledComponent = styled(function (props) {
    var _a, _b, _c, _d;
    var onCellClick = props.onCellClick, onCellKeyDown = props.onCellKeyDown, onCellEditStart = props.onCellEditStart, onCellEditStop = props.onCellEditStop, columnMenu = props.columnMenu, columnSelector = props.columnSelector, columnFilter = props.columnFilter, densitySelector = props.densitySelector, disableRowSelectionOnClick = props.disableRowSelectionOnClick, isCellEditable = props.isCellEditable, columnVisibilityModel = props.columnVisibilityModel, slots = props.slots, sx = props.sx, rest = __rest(props, ["onCellClick", "onCellKeyDown", "onCellEditStart", "onCellEditStop", "columnMenu", "columnSelector", "columnFilter", "densitySelector", "disableRowSelectionOnClick", "isCellEditable", "columnVisibilityModel", "slots", "sx"]);
    if (sx)
        console.error('The sx prop is not used in StyledComponent');
    return (_jsx(DataGrid, __assign({ density: "compact" }, rest, { disableColumnMenu: (_a = !columnMenu) !== null && _a !== void 0 ? _a : true, disableColumnSelector: (_b = !columnSelector) !== null && _b !== void 0 ? _b : true, disableColumnFilter: (_c = !columnFilter) !== null && _c !== void 0 ? _c : true, disableDensitySelector: (_d = !densitySelector) !== null && _d !== void 0 ? _d : true, disableRowSelectionOnClick: disableRowSelectionOnClick !== null && disableRowSelectionOnClick !== void 0 ? disableRowSelectionOnClick : false, slots: __assign({ baseCheckbox: MoaCheck }, slots), slotProps: {
            row: {
                rowHeight: 32,
            },
            cell: {
                align: "center",
                height: 32,
            },
        }, rowHeight: 32, isCellEditable: isCellEditable !== null && isCellEditable !== void 0 ? isCellEditable : undefined, columnVisibilityModel: columnVisibilityModel !== null && columnVisibilityModel !== void 0 ? columnVisibilityModel : undefined, sx: {
            ".MuiDataGrid-columnHeaders": {
                fontWeight: 500,
                backgroundColor: Color.component.gray_light,
            },
            ".MuiDataGrid-columnSeparator": {
                color: Color.component.gray,
            },
            ".MuiDataGrid-columnHeaderTitleContainer": {
                justifyContent: "center",
            },
            ".MuiDataGrid-cell:focus": {
                outline: "solid ".concat(Color.primary.focus, " 1px"),
            },
            ".MuiDataGrid-row.Mui-selected:hover": {
                backgroundColor: Color.component.gray_02,
            },
            ".MuiDataGrid-row.Mui-selected": {
                backgroundColor: Color.component.gray_02,
            },
            ".MuiDataGrid-toolbarContainer": {
                backgroundColor: Color.component.gray_light,
            },
            ".MuiButtonBase-root": {
                color: Color.primary.hover,
                fontSize: '0.7rem',
                textTransform: 'none',
            },
            ".MuiButtonBase-root:hover": {
                backgroundColor: Color.primary.hover,
                color: Color.primary.white,
            },
            ".MuiButton-startIcon": {
                fontSize: '1rem',
            },
            ".MuiSvgIcon-root": {
                fontSize: '1rem',
            },
        }, onCellClick: onCellClick, onCellKeyDown: onCellKeyDown, onCellEditStart: onCellEditStart, onCellEditStop: onCellEditStop })));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
export { GridToolbar, GridToolbarContainer, GridToolbarExport, };
